import { css } from "@emotion/react";
import { FONTS } from "../../../styles/fonts";
import { CSS_MQ } from "../../../styles/breakpoints";
import React from "react";
import { ExpandedTagT } from "@swo/shared";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CloseButtonSvg } from "../../../assets";

export const ActiveTagsList: React.FC<{ activeTags: Array<ExpandedTagT> }> = props => {
  if (props.activeTags.length <= 0) {
    return null;
  }

  return (
    <div css={tagsWrapperStyles}>
      {props.activeTags.map(t => (
        <span
          key={t.link}
          css={css`
            margin-right: 20px;
            text-transform: uppercase;

            display: inline-flex;
            align-items: center;
          `}
        >
          <EXPERIMENTAL_TextWithProductNameRenderer text={t.label} />

          <SwarovskiLink
            scrollToTop={true}
            expectSimilarLayout={true}
            isInternal={true}
            link={t.expandedLink}
            styled={"no-decoration"}
            attachStyles={css`
              color: ${CSS_COLORS.Green};
              display: flex;
            `}
          >
            <CloseButtonSvg
              css={css`
                width: 36px;
                height: 36px;
                padding: 8px;
              `}
            />
          </SwarovskiLink>
        </span>
      ))}
    </div>
  );
};

const tagsWrapperStyles = css`
  ${FONTS.MinervaModern500};
  color: ${CSS_COLORS.Green};

  font-size: 24px;
  letter-spacing: 0.4px;
  line-height: 26px;

  ${CSS_MQ.atLeastMd} {
    font-size: 40px;
    letter-spacing: 2px;
    line-height: 42px;
  }

  margin-bottom: 20px;

  ${CSS_MQ.atLeastMd} {
    margin-bottom: 30px;
  }
`;
